<div class="empty-route-container">
  <div class="empty-route-error-number">404</div>
  <div class="empty-route-error-text">Page Not Found</div>
  <div class="empty-route-error-note">Sorry, but we can't find the page you are looking for.</div>
</div>